export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/b552ae94a3baa9664c4076d726380c66.svg";